import { Controller } from '@hotwired/stimulus';
import { showModal, hideModal } from '../utils/modal';
import Cookies from 'js-cookie';

export default class extends Controller {
  initialize() {
    if (!Cookies.get('account_expiration')) {
      showModal('account-expiration', { disableFocus: true });
      this.hasSeenModal();
    }
  }

  close() {
    event.cancelBubble = true;
    hideModal('account-expiration');
  }

  hasSeenModal() {
    Cookies.set('account_expiration', Date.now(), { expires: 7 });
  }
}
